module.exports = __webpack_public_path__ + "static/media/team1.a9f54a43.png";